import React from 'react';
import { importRemote } from '@module-federation/utilities';
import useSiteData from '../../../hooks/useSiteData';
import useIdentityContext from '../../../hooks/useIdentityContext';
import { useExpressCheckoutContext } from '../../contexts/ExpressCheckoutContext';
import { DYNAMIC_EXPRESS_CHECKOUT } from '../../../constants/moduleFederation';

import {
  CART_PAGE_SECTION,
  CART_PAGE_STAGE,
  CART_PAGE_NAME,
} from '../../../constants/cartui';
import type { DynamicExpressCheckoutProps, PageDetails } from '../../../types';

export const DynamicExpressCheckout = ({
  showExpressCheckoutFlyout,
  setShowExpressCheckoutFlyout,
}: DynamicExpressCheckoutProps) => {
  const { locale } = useSiteData();
  const {
    auth,
    identity: { shopperId },
  } = useIdentityContext();

  const { cartTenantDetails, setIsDynamicLoadFailure } =
    useExpressCheckoutContext();
  const pageDetails: PageDetails = {
    pageName: CART_PAGE_NAME,
    pageSection: CART_PAGE_SECTION,
    pageStage: CART_PAGE_STAGE,
  };

  const ExpressCheckout = React.lazy(() =>
    importRemote<any>({
      url: DYNAMIC_EXPRESS_CHECKOUT.url,
      scope: DYNAMIC_EXPRESS_CHECKOUT.scope,
      module: DYNAMIC_EXPRESS_CHECKOUT.module,
      remoteEntryFileName: DYNAMIC_EXPRESS_CHECKOUT.fileName,
      bustRemoteEntryCache: false,
    }).catch(() => {
      setIsDynamicLoadFailure(true);
      return { default: () => null };
    })
  );

  if (!cartTenantDetails || Object.keys(cartTenantDetails).length === 0) {
    console.error('Error preparing express checkout');
    return null;
  }

  return (
    <div>
      <React.Suspense fallback={null}>
        <ExpressCheckout
          showExpressCheckout={showExpressCheckoutFlyout}
          setShowExpressCheckout={setShowExpressCheckoutFlyout}
          shopperId={shopperId}
          locale={locale}
          auth={auth}
          pageDetails={pageDetails}
          tenantDetails={cartTenantDetails}
          cartDetails={{ type: 'default' }}
        />
      </React.Suspense>
    </div>
  );
};
